/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — MIT white-label additions
 * to Chatwoot Community Edition. Not derived from the commercial code under enterprise/.
 */
import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bot-documents'),
      component: SettingsWrapper,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          name: 'bot_documents_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
